import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './EndorsementComponent.scss';

export default class EndorsementComponent extends Component {
    state = {
        activeEndorsementList: [],
        activeCount: 0
    };

    static get propTypes() {
        return {
            endorsementList: PropTypes.array,
            onClick: PropTypes.func
        };
    }

    onClickEndorsement(endorsement) {
        let activeEndorsementList = this.state.activeEndorsementList;
        let index = activeEndorsementList.indexOf(endorsement);

        if (index === -1) {
            activeEndorsementList.push(endorsement);
        } else {
            activeEndorsementList.splice(index, 1);
        }
        this.setState({
            activeEndorsementList: activeEndorsementList,
            activeCount: activeEndorsementList.length
        });
        this.props.onClick && this.props.onClick('[' + activeEndorsementList.toString() + ']');
    }

    render() {
        const {endorsementList} = this.props;
        const activeCount = this.state.activeCount;
        const endorsementListLength = this.props.endorsementList.length;

        return (
            <div className="endorsement-component">
                <div className="endorsement-list">
                    {endorsementList.map(endorsement => {
                        return <div key={endorsement.endorsementId}
                                   className={this.state.activeEndorsementList.includes(endorsement.endorsementId) ? 'selected' : ''}
                                   onClick={() => this.onClickEndorsement(endorsement.endorsementId)}>
                            {this.state.activeEndorsementList.includes(endorsement.endorsementId) ? <span className='dash'>&ndash;</span> : <span className='dash'>&#43;</span>}
                            {endorsement.title}</div>;
                    })}
                </div>
                <p className="count-selected hidden-xs">({activeCount} of {endorsementListLength} selected)</p>
            </div>
        );
    }
}
